import { FC } from "react";
import { Listbox, ListboxOption, ListboxOptions } from "@headlessui/react";
import { ListboxButton } from "./ListboxButton";
import { TypedVoidFunc } from "../../../helpers/functions/types";
import { SortOptions } from "./index";
import { AttributeFilters } from "../../../product/details/components/tabs/constants/types";

type SelectProps<T> = {
  options: T[];
  activeOption: T;
  handleSelect: TypedVoidFunc<T>;
  customText?: string;
};
export const Select: FC<
  React.PropsWithChildren<
    | SelectProps<string>
    | SelectProps<SortOptions | undefined>
    | SelectProps<AttributeFilters>
  >
> = ({ options, activeOption, handleSelect, customText }) => {
  const descriptionText = customText ?? "Sort by";
  return (
    <Listbox value={activeOption} onChange={handleSelect}>
      <ListboxButton title={`${descriptionText} ${activeOption}`} />
      <ListboxOptions className="absolute z-10 mt-7 cursor-pointer overflow-y-auto rounded-md bg-stone-50 px-3 text-sm font-medium shadow-lg ring-1 ring-black/5 focus:outline-none dark:bg-stone-600 dark:text-stone-300 ">
        {options.map((option, index) => (
          <ListboxOption key={index} value={option} className="py-2">
            {`${descriptionText} ${option}`}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </Listbox>
  );
};
